export const media = {
  mobile: "(max-width: 375px)",
  tablet: "(max-width: 768px)",
  desktop: "(max-width: 1152px)",
}